<template>
    <div>
        <NavbarStyleTwo />
        <!-- <PageTitle
            pageTitle="Referenzen"
            pageDesc="Überzeugen Sie sich von unseren erfolgreichen Projekten"
        /> -->
        <InspirationShowcase />
        <Referenzen />
        <Footer :showDivider="true" />
    </div>
</template>

<script>
import { useHead } from '@vueuse/head';
import NavbarStyleTwo from '../Layouts/NavbarStyleTwo';
// import PageTitle from '../Common/PageTitle';
import InspirationShowcase from '../Common/InspirationShowcase';
import Referenzen from '../Common/Referenzen';
import Footer from '../Layouts/Footer';

export default {
    name: 'ReferenzenPage',
    setup() {
        useHead({
            title: 'Referenzen - Projekte & Portfolio | Benovium',
            meta: [
                { name: 'description', content: 'Entdecken Sie unsere erfolgreichen Webprojekte. Landingpages, Webshops und Unternehmenswebseiten aus Wien. Überzeugen Sie sich von unserer Arbeit.' },
                { property: 'og:title', content: 'Referenzen - Benovium' },
                { property: 'og:description', content: 'Erfolgreiche Webprojekte aus Wien.' },
                { property: 'og:url', content: 'https://benovium.com/referenzen' },
            ],
            link: [
                { rel: 'canonical', href: 'https://benovium.com/referenzen' }
            ]
        });
    },
    components: {
        NavbarStyleTwo,
        // PageTitle,
        InspirationShowcase,
        Referenzen,
        Footer,
    }
};
</script>
